document.addEventListener('DOMContentLoaded', () => {
  function checkMenu() {
    document.querySelectorAll('#header .w-dropdown-list:not(.w--open)').forEach((ddl) => {
      if (ddl.style.opacity == '0' && ddl.style.display == 'flex') {
        ddl.style.display = 'none';
      }
    });
    window.requestAnimationFrame(checkMenu);
  }
  window.requestAnimationFrame(checkMenu);
});
